import { render, staticRenderFns } from "./masterdata-summary-item.vue?vue&type=template&id=3cde0c69&scoped=true&lang=pug"
import script from "./masterdata-summary-item.vue?vue&type=script&lang=ts"
export * from "./masterdata-summary-item.vue?vue&type=script&lang=ts"
import style0 from "./masterdata-summary-item.vue?vue&type=style&index=0&id=3cde0c69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde0c69",
  null
  
)

export default component.exports